import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { tableHeader } from './style'

class TableHeader extends PureComponent {
  static propTypes = {}

  static defaultProps = {}

  render() {
    const { fields, tableGuid } = this.props

    return (
      <div className="table-header-container">
        {fields.map((field, index) => (
          <div
            className="table-header-field"
            key={`${tableGuid}-${index}`}
            style={{ width: field.width }}
          >
            {field.caption}
          </div>
        ))}
        <style jsx>{tableHeader}</style>
      </div>
    )
  }
}

export default TableHeader
